/**
 * The practice's lens catalogue: the spectacle lenses and contact lens products it prescribes and
 * dispenses. Mirrors /api/lens-catalogue on the REST API. Lens suppliers publish no catalogue API, so
 * each practice keeps its own, started from a default catalogue the first time it is read.
 */
app.service("LensCatalogueAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		const baseUri = ENV.API + "/api/lens-catalogue";

		const getHeaders = function () {
			return {
				Authorization: "Bearer " + Session.token,
				"X-PRACTICE-ID": `${Session.practice.id}`,
			};
		};

		var service = {
			/**
			 * The practice's active lenses, ordered by brand then name.
			 * @param {string} [pathway] - GLASSES or CONTACTS; leave out for both.
			 */
			getItems: function (pathway) {
				return $http({
					method: "GET",
					url: `${baseUri}/items`,
					headers: getHeaders(),
					params: pathway ? { pathway: pathway } : {},
				});
			},
		};

		return service;
	},
]);
